// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vZBxr{display:-webkit-box;display:flex;gap:1.25rem;-webkit-box-align:center;align-items:center;-webkit-box-pack:justify;justify-content:space-between;margin:.75rem 0 .5rem}.e_o3w{gap:.5rem}.ekwEM{color:#202626;color:#747c7f;display:-webkit-box;display:flex;font-family:Inter,sans-serif;font-size:.875rem;font-weight:400;gap:.25rem;letter-spacing:0;line-height:1.35}.X5nyS{overflow:hidden;text-overflow:ellipsis;word-break:break-all;line-clamp:1;-webkit-line-clamp:1;-webkit-box-orient:vertical}.EjQoI,.X5nyS{display:-webkit-box}.EjQoI{display:flex;flex-shrink:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `vZBxr`,
	"root_popup": `e_o3w`,
	"overview": `ekwEM`,
	"heading": `X5nyS`,
	"guests": `EjQoI`
};
module.exports = ___CSS_LOADER_EXPORT___;
